var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStepCadIcon = function SvgStepCadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    fill: "none",
    viewBox: "0 0 21 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B75332",
    d: "M5.248 6.77a.72.72 0 0 1 1.019-1.02l3.09 3.092V1.22a.72.72 0 1 1 1.44 0v7.622l3.09-3.091a.72.72 0 0 1 1.02 1.018l-4.32 4.32a.72.72 0 0 1-1.02 0zm14.91 4.53v5.76a1.44 1.44 0 0 1-1.44 1.44H1.437a1.44 1.44 0 0 1-1.44-1.44V11.3a1.44 1.44 0 0 1 1.44-1.44h4.715a.36.36 0 0 1 .255.105l2.14 2.145a2.16 2.16 0 0 0 3.06 0l2.141-2.142a.36.36 0 0 1 .252-.108h4.716a1.44 1.44 0 0 1 1.44 1.44m-3.6 2.88a1.08 1.08 0 1 0-2.16 0 1.08 1.08 0 0 0 2.16 0"
  })));
};
export { SvgStepCadIcon as ReactComponent };
export default "/_next/static/media/static/media/Step-Cad Icon.d3b5b29636affb172fb700cdc704a977svg";